import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-briefcase-02',
  standalone: true,
  templateUrl: './rt-icon-briefcase-02.component.html',
  styleUrls: ['./rt-icon-briefcase-02.component.scss']
})
export class RtIconBriefcase02Component {
  @Input() width: number | string = 17;
  @Input() height: number | string = 15;
}
